import React, { createContext, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useVisualViewport } from '@wix/da-ds/pkg/hooks/useVisualViewport';
import { MeasuredCookieType } from '../redux/types';
import { useMeasuredCookieState, DEFAULT_SIZE } from '../useMeasuredCookieState';
export const ScreenSizeContext = /*#__PURE__*/ createContext(DEFAULT_SIZE.desktop);
ScreenSizeContext.displayName = 'ScreenSizeContext';
export const ScreenSizeContextProvider = ({ children })=>{
    const isMobile = useContext(MobileContext);
    const { containerSize = isMobile ? DEFAULT_SIZE.mobile : DEFAULT_SIZE.desktop, updateContainerSize } = useMeasuredCookieState(MeasuredCookieType.SCREEN_WIDTH, 'both', DEFAULT_SIZE);
    // VisualViewport
    useVisualViewport(updateContainerSize);
    return /*#__PURE__*/ React.createElement(ScreenSizeContext.Provider, {
        value: containerSize
    }, children);
};
ScreenSizeContextProvider.displayName = 'ScreenSizeContextProvider';
